export default __webpack_public_path__ + "static/media/shuffle.46b46453.svg";